import { combineReducers } from '@reduxjs/toolkit';
import { reducer as toastrReducer } from "react-redux-toastr";
import { app } from "./appReducer";
import { auth } from "./authReducer";
import { validateRegisterIs } from "./validateRegisterIsReducer";
import { confirmationRegisterIs } from "./confirmationRegisterIsReducer";
import { schoolsReducer } from "./schoolsReducer";
import { studentsReducer } from "./studentsReducer";
import { insuranceReducer, houseInsuranceReducer, multimediaInsuranceReducer } from "./insuranceReducer";
import { contracts } from "./contractsReducer";
import { claims } from "./claimsReducer";
import { habitationReducer } from '@/features/habitation/habitationSlice';
import { rcReducer } from '@/features/rc/rcSlice';
import { santeMobiliteReducer } from '@/features/sante-mobilite/santeMobiliteSlice';
import { offersReducer } from "./offersReducer";
import { userReducer } from "@/features/habitation/userSlice";
import profileReducer from '@/features/profile/profileSlice';

const rootReducer = combineReducers({
  app,
  auth,
  validateRegisterIs,
  confirmationRegisterIs,
  school: schoolsReducer,
  students: studentsReducer,
  insurance: insuranceReducer,
  toastr: toastrReducer,
  contracts,
  claims,
  houseInsurance: houseInsuranceReducer,
  multimediaInsurance: multimediaInsuranceReducer,
  offersInsurance: offersReducer,
  habitation: habitationReducer,
  rc: rcReducer,
  santeMobilite: santeMobiliteReducer,
  user: userReducer,
  profile: profileReducer,
});

export default rootReducer; 
export type RootReducerType = typeof rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
